<template>
  <div>
    <el-form ref="searchform" :model="searchform" label-width="75px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="品牌" prop="brandId">
            <el-select v-model="searchform.brandId" placeholder="请选择" style="width:100%">
              <el-option
                v-for="item in barndlist"
                :key="item.brand_id"
                :label="item.brand_name"
                :value="item.brand_id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="扫码日期" prop="datelist">
            <el-date-picker
              style="width:100%"
              v-model="searchform.datelist"
              type="daterange"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="1">
          <el-button @click="resetForm('searchform')">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getscancount('searchform')"></el-button>
        </el-col>
      </el-row>
    </el-form>
    <line-charta :chart-data="lineChartData" />
  </div>
</template>

<script>
import LineCharta from "../LineCharta";
import { scancount } from "@/api/report";
import { productlist, productTree } from "@/api/base";
export default {
  components: {
    LineCharta
  },
  data() {
    return {
      lineChartData: {
        actualData: [],
        chartdatelist: []
      },
      // 扫码查询参数
      searchform: {
        brandId: null,
        datelist: null
      },
      productlist: [],
      barndlist: []
    };
  },
  methods: {
    // 扫码查询次数
    getscancount() {
      scancount({
        brandId: this.searchform.brandId,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.lineChartData.actualData = [];
        this.lineChartData.chartdatelist = [];
        for (let i = 0; i < response.data.length; i++) {
          this.lineChartData.actualData.push(response.data[i].qty);
          response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
          this.lineChartData.chartdatelist.push(response.data[i].createDate);
        }
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    // 图表初始数据调用
    this.getscancount();
    productTree().then(response => {
      this.barndlist = response.data;
    });
  }
};
</script>
<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
